import { TEXT_ENCODING, UI_LABELS_JSON } from "@limitless/common/apis/resource-api";
export const REASON_CODE_JSON = {
  name: "messageCodes.json",
  encoding: TEXT_ENCODING
};
export const TAGS_JSON = {
  name: "messageTags.json",
  encoding: TEXT_ENCODING
};
export const MESSAGE_RESOURCES = [REASON_CODE_JSON, TAGS_JSON, UI_LABELS_JSON];